import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import clsx from 'clsx';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { ReportQueryResult } from '../../Interfaces/Reports/ReportQueryResult';
import { getLocalDateTime } from '../../utils/utils';
import StringResourceManager from '../StringResourceManager';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogLabel: {
      fontSize: '1.1rem',
      display: 'inline',
    },
    dialogTextBold: {
      fontWeight: 'bold',
    },
  })
);

const ReportsGeneratedDateTimeGridItem: React.FC = (): React.ReactElement => {
  const classes = useStyles();

  const reportData: ReportQueryResult = useSelector(
    (state: ApplicationState) => state.reportsReducer.reportData
  );

  return (
    <Grid item md={6} xs={12}>
      <StringResourceManager
        stringKey={'REPORTS_GENERATED_ON'}
        variant="body1"
        style="dialogLabel"
        gutterBottom={true}
      />
      <Typography
        variant="body1"
        className={clsx(classes.dialogLabel, classes.dialogTextBold)}
        gutterBottom
      >
        {getLocalDateTime(reportData.GeneratedDateTime)}
      </Typography>
    </Grid>
  );
};

export default ReportsGeneratedDateTimeGridItem;
